import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SelectOption } from '../options/options.component';

@Component({
  selector: 'timer-options',
  templateUrl: './timer-options.component.html',
  styleUrls: ['./timer-options.component.scss']
})
export class TimerOptionsComponent implements OnInit {

  @Input() selectedRounds;
  @Input() selectedRoundLength;
  @Input() selectedRestLength;

  @Output() onAllSelected = new EventEmitter();

  roundNumbers: Array<SelectOption>;
  roundLength: Array<SelectOption>;
  restLength: Array<SelectOption>;

  constructor() { }

  onDone(){
    if (this.selectedRounds && this.selectedRoundLength && this.selectedRestLength) {
      this.onAllSelected.emit({ rounds: this.selectedRounds, roundLength: this.selectedRoundLength, restLength: this.selectedRestLength });
    }
  }
  onSelectChanges(ev) {
    // if (this.selectedRounds && this.selectedRoundLength && this.selectedRestLength) {
    //   this.onAllSelected.emit({ rounds: this.selectedRounds, roundLength: this.selectedRoundLength, restLength: this.selectedRestLength });
    // }
  }

  ngOnInit() {
    this.roundNumbers = new Array();

    for (let i = 1; i < 15; ++i) {
      this.roundNumbers.push({ text: i.toString(), value: i.toString() });
    }

    this.roundLength = new Array();
    this.roundLength.push({ text: ':30', value: '30' })
    this.roundLength.push({ text: '1:00', value: '60' })
    this.roundLength.push({ text: '1:30', value: '90' })
    this.roundLength.push({ text: '2:00', value: '120' })
    this.roundLength.push({ text: '2:30', value: '150' })
    this.roundLength.push({ text: '3:00', value: '180' })
    this.roundLength.push({ text: '3:30', value: '210' })
    this.roundLength.push({ text: '4:00', value: '240' })
    this.roundLength.push({ text: '5:00', value: '300' })


    this.restLength = new Array();
    this.restLength.push({ text: ':15', value: '15' })
    this.restLength.push({ text: ':30', value: '30' })
    this.restLength.push({ text: ':45', value: '45' })
    this.restLength.push({ text: '1:00', value: '60' })
    this.restLength.push({ text: '1:30', value: '90' })
    this.restLength.push({ text: '2:00', value: '120' })
    this.restLength.push({ text: '2:30', value: '150' })
    this.restLength.push({ text: '3:00', value: '180' })
  }

}
